import { Order } from 'entities/orders/model/types';
import { FC } from 'react';
import { Typography } from 'shared/ui/typography';
import guests from 'assets/icons/Guests.svg';
import flash from 'assets/icons/flash.svg';
import { Flex } from 'shared/ui/flex';

export const OrderParticipants: FC<{ order: Order }> = ({ order }) => {
	return (
		<Typography
			icon={{ src: guests, align: 'end', size: 'small' }}
			pointer={true}
			style={{ minWidth: '24px' }}
		>
			<Flex>
				{order.participants_count}
				{order.appointment?.bypass && <img src={flash} style={{ marginLeft: '4px' }} />}
			</Flex>
		</Typography>
	);
};
